import React from 'react';

/*
 * Displays the survey type based on the Done survey that was started
 */
export default settings => {
    return ({ value, row }) => {
        const youthAssignment = ['assignment29', 'assignment30'];
        const teenAssignment = ['assignment27', 'assignment28'];

        let type = '';

        let assignmentHandle = row['assignmentProgress.assignmentHandle'];
        if (youthAssignment.includes(assignmentHandle)) {
            type = 'youth';
        } else if (teenAssignment.includes(assignmentHandle)) {
            type = 'teen';
        }

        return <div>{type}</div>;
    };
};
